/* eslint-disable import/extensions */
import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import { RadioGroup } from '@masfront/common-b2c'
import { Field, Formik, FormikProps, getIn } from 'formik'

import {
  Box,
  Typography,
  Link,
  Divider,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core'

import contractDestinationSchema from './BillingSummary.schemas'

import { ContractDestination } from '../../model/billing.model'
import { setFields } from '../../store/payments.reducer'
import { selectContractDestination, selectIban } from '../../store/payments.selectors'

import { selectBillingAddress } from '~/address/store/address.selectors'
import PATHS from '~/router/paths'

type ContractDestinationFormType = {
  contractDestination: string | undefined
}

const contractDestinations: ContractDestination[] = [
  { id: 'mysim', value: 'Área de cliente MySIM' },
  { id: 'email', value: 'Email' },
  { id: 'none', value: 'Este cliente no tiene email' },
]

function ContractDestinationForm({
  errors,
  touched,
  values,
}: FormikProps<ContractDestinationFormType>) {
  const contractDestinationError = useMemo(
    () => getIn(touched, 'contractDestination') && getIn(errors, 'contractDestination'),
    [touched, errors],
  )
  const dispatch = useDispatch()

  const setFieldsValues = useCallback(() => {
    dispatch(setFields(values))
  }, [values])

  useEffect(() => {
    setFieldsValues()
  }, [values])

  return (
    <Field component={RadioGroup} name="contractDestination">
      <Box display="flex" flexWrap="wrap" alignItems="center">
        {contractDestinations?.map(({ id, value }) => (
          <FormControlLabel
            key={`contractDestination-${id}`}
            value={value}
            control={<Radio color="primary" data-hook={value} />}
            label={value}
          />
        ))}
        <FormHelperText error>{contractDestinationError}</FormHelperText>
      </Box>
    </Field>
  )
}

export default function BillingSummary() {
  const account = useSelector(selectIban)
  const address = useSelector(selectBillingAddress)
  const contractDestination = useSelector(selectContractDestination)

  return (
    <Box>
      <Box py={5} px={6}>
        <Typography variant="h3">Datos de Facturación</Typography>
      </Box>
      <Divider />
      <Box px={6} pb={6}>
        <Box>
          <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
            <Typography variant="body2">Número de cuenta o IBAN: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook="summary-account">
                {account.value}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
            <Typography variant="body2">Dirección:</Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook="summary-address">
                {address}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Link component={RouterLink} to={PATHS.BILLING} underline="always">
              Modificar datos de facturación
            </Link>
          </Box>
        </Box>
      </Box>
      <Box px={6} pt={2}>
        <Typography variant="subtitle1">¿DÓNDE QUIERE RECIBIR LA FACTURA?</Typography>
        <Box display="flex" flexDirection="row" alignItems="baseline" mt={2} mb={4}>
          <Formik
            initialValues={{
              contractDestination: contractDestination?.value,
            }}
            initialStatus={{}}
            validateOnBlur={false}
            validateOnMount
            validationSchema={contractDestinationSchema}
            onSubmit={(values, formik) => {
              formik.setSubmitting(false)
            }}
            component={ContractDestinationForm}
          />
        </Box>
      </Box>
    </Box>
  )
}
